// Service Worker registration for offline support.
// Uses the CRA-compatible approach: registers /service-worker.js from the public folder.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production') {
    if (!('serviceWorker' in navigator)) return;
    const scriptUrl = new URL(`${process.env.PUBLIC_URL || ''}/service-worker.js`, window.location.href).href;
    const isAppWorker = worker => worker?.scriptURL === scriptUrl;
    const controlled = isAppWorker(navigator.serviceWorker.controller);
    // Remove an existing app worker before reloading the development bundle.
    return navigator.serviceWorker.getRegistrations()
      .then(registrations => Promise.all(registrations
        .filter(registration => [registration.active, registration.waiting, registration.installing].some(isAppWorker))
        .map(registration => registration.unregister())))
      .then(() => { if (controlled) window.location.reload(); })
      .catch(error => console.error('[SW] Development cleanup failed:', error));
  }
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // In localhost, verify the SW exists before registering.
        checkValidServiceWorker(swUrl);
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content available — will be used after page reload.
              console.info('[SW] New content available. Refresh to update.');
            } else {
              // Content cached for offline use.
              console.info('[SW] Content cached for offline use.');
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[SW] Registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // SW not found — unregister and reload.
        navigator.serviceWorker.ready.then((reg) => {
          reg.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.info('[SW] No internet connection. App running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
